import { render } from "./StickyModalComponent.vue?vue&type=template&id=1c910faa&scoped=true"
import script from "./StickyModalComponent.vue?vue&type=script&lang=js"
export * from "./StickyModalComponent.vue?vue&type=script&lang=js"

import "./StickyModalComponent.vue?vue&type=style&index=0&id=1c910faa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c910faa"]])

export default __exports__